import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ProjectTwoToneSvg from "@ant-design/icons-svg/es/asn/ProjectTwoTone";
import AntdIcon from "../components/AntdIcon";
var ProjectTwoTone = function ProjectTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ProjectTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ProjectTwoTone.displayName = 'ProjectTwoTone';
}
export default /*#__PURE__*/React.forwardRef(ProjectTwoTone);